import React from 'react'
import { cn } from '@/modern/utils'

export function BaseModalFooter({children, className = ""}) {
  return (
    <div className={cn("flex justify-end gap-4 p-swivu-base border-t border-border border-solid w-full", className)}>
      {children}
    </div>
  )
}